<template>
    <div class="filtros-extras">
        <b-collapse
            class="card"
            :open.sync="filtroIsOpen"
            @open="$emit('scrollElement', 'filterTable')"
            animation="slide"
        >
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'" />
                        {{ $t('filtros') }}
                    </div>
                </div>
            </div>

            <div class="card-content">
                <div class="columns is-multiline card-content-section">
                    <div
                        v-if="mostraFiltroEmpresa"
                        class="column is-one-third is-full-mobile card-content-top"
                    >
                        <vss-select
                            :id="generateId(69)"
                            title="filtro-empresa"
                            :value="empresaSelected"
                            :options="empresaSelect"
                            :loading="empresaLoading"
                            :ml-labels-field="'traduzir'"
                            @input="updateEmpresa"
                            noClearfix
                        />
                    </div>
                    <div
                        v-if="mostraFiltroVendedor"
                        class="column is-one-third is-full-mobile card-content-top"
                    >
                        <vss-select
                            :id="generateId(70)"
                            :value="vendedorSelected"
                            title="filtro-vendedor"
                            :options="vendedorSelect"
                            :loading="vendedorLoading"
                            @search="carregarVendedores"
                            @input="updateVendedor"
                            label="nome"
                            multiple
                            searchable
                            clearable
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(71)"
                            :value="atividadeSelected"
                            title="filtro-atividade"
                            :options="atividadeSelect"
                            :loading="atividadeLoading"
                            @search="carregarAtividades"
                            @input="updateAtividade"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(72)"
                            :value="situacaoSelected"
                            title="filtro-situacao"
                            :options="situacaoSelect"
                            :loading="situacoesLoading"
                            @search="carregarSituacoes"
                            @input="updateSituacao"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            noClearfix
                        />
                    </div>
                    <div
                        class="column is-one-third is-full-mobile card-content-top"
                        v-if="
                            pdadetalhe['registro_enviado'] && !pdadetalhe['registro_enviado'].oculta
                        "
                    >
                        <vss-select
                            class="form-height"
                            label="label"
                            :options="statusSelect"
                            :loading="statusLoading"
                            @input="updateStatus"
                            v-model="statusSelected"
                            title="status"
                            :onBlurFunction="alterValuesOrigemByStatus"
                        />
                    </div>
                    <div
                        class="column is-one-third is-full-mobile card-content-top"
                        v-if="
                            pdadetalhe['registro_enviado'] && !pdadetalhe['registro_enviado'].oculta
                        "
                    >
                        <vss-select
                            class="form-height"
                            label="label"
                            :options="origemSelect"
                            :loading="origemLoading"
                            @input="updateOrigem"
                            v-model="origemSelected"
                            title="origem"
                            :onBlurFunction="alterValuesStatusByOrigem"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(75)"
                            title="filtro-visita"
                            :value="visitaSelected"
                            :options="visitaSelect"
                            @input="updateVisita"
                            ml-labels
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(76)"
                            :value="cidadeSelected"
                            title="filtro-cidade"
                            :options="cidadeSelect"
                            :loading="cidadeLoading"
                            @search="carregarCidades"
                            @input="updateCidade"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(77)"
                            :value="regiaoSelected"
                            title="filtro-regiao"
                            :options="regiaoSelect"
                            :loading="regiaoLoading"
                            @search="carregarRegioes"
                            @input="updateRegiao"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(78)"
                            title="filtro-geolocalizacao"
                            :value="geolocalizacaoSelected"
                            :options="geolocalizacaoSelect"
                            @input="updateGeolocalizacao"
                            ml-labels
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(79)"
                            title="filtro-contatos"
                            :value="contatoSelected"
                            :options="contatoSelect"
                            @input="updateContatos"
                            ml-labels
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(80)"
                            title="nao-venda"
                            :value="naoVendaSelected"
                            :options="naoVendaSelect"
                            @input="updateNaoVendas"
                            ml-labels
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(81)"
                            :value="statusComercialSelected"
                            title="filtro-status-comercial"
                            :options="statusComercialSelect"
                            :loading="statusComercialLoading"
                            @search="carregarStatusComerciais"
                            @input="updateStatusComerciais"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <v-input
                            class="field"
                            :id="generateId(82)"
                            title="filtro-sem-venda-a-mais-de-x-dias"
                            v-model="minDiasDesdeUltimaVenda"
                            @input="updateMinDiasDesdeUltimaVenda"
                            :min="0"
                            :maxlength="10"
                            :validchars="'0123456789'"
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <v-input
                            class="field"
                            :id="generateId(83)"
                            v-model="minDiasDesdeUltimaAtualizacao"
                            title="filtro-sem-atualizacao-a-mais-de-x-dias"
                            @input="updateMinDiasDesdeUltimaAtualizacao"
                            :min="0"
                            :maxlength="10"
                            :validchars="'0123456789'"
                            noClearfix
                        />
                    </div>
                    <!-- Filtros novos -->
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(100)"
                            :value="grupoEconomicoSelected"
                            title="grupo-economico"
                            :options="grupoEconomicoSelect"
                            :loading="grupoEconomicoLoading"
                            @search="carregarGrupoEconomico"
                            @input="updateGrupoEconomico"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(101)"
                            :value="areainteresseSelected"
                            title="cli-areainteresse"
                            :options="areainteresseSelect"
                            :loading="areainteresseLoading"
                            @search="carregarAreainteresse"
                            @input="updateAreainteresse"
                            label="descricao"
                            noClearfix
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <v-input
                            class="field"
                            :id="generateId(102)"
                            v-model="propriedade"
                            title="propriedade"
                            @input="updatePropriedade"
                            placeholder="busca"
                            noClearfix
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            :id="generateId(103)"
                            title="planosafra"
                            :value="planosafraSelected"
                            :options="planosafraSelect"
                            @input="updatePlanosafra"
                            ml-labels
                            noClearfix
                        />
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import ColaboradorService from '@/services/ColaboradorService';
import AtividadeService from '@/services/AtividadeService';
import SituacaoService from '@/services/SituacaoService';
import CidadeService from '@/services/CidadeService';
import RegiaoService from '@/services/RegiaoService';
import StatusComercialService from '@/services/StatusComercialService';
import ClienteService from '@/services/promotor/ClienteService';
import GrupoEconomicoService from '@/services/agro/GrupoEconomicoService';
import AreaInteresseService from '@/services/agro/AreaInteresseService';

export default {
    props: {
        limparFiltros: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            atividadeService: new AtividadeService(this.$http, this.$router),
            situacaoService: new SituacaoService(this.$http, this.$router),
            cidadeService: new CidadeService(this.$http, this.$router),
            regiaoService: new RegiaoService(this.$http, this.$router),
            statusComercialService: new StatusComercialService(this.$http, this.$router),
            clienteService: new ClienteService(this.$http, this.$router),
            grupoEconomicoService: new GrupoEconomicoService(this.$http, this.$router),
            areaInteresseService: new AreaInteresseService(this.$http, this.$router),

            filtroIsOpen: false,
            primeiraExecucao: true,

            empresaSelect: [],
            empresaSelected: null,
            mostraFiltroEmpresa: false,
            empresaLoading: false,

            vendedorSelect: [],
            vendedorSelected: [],
            mostraFiltroVendedor: false,
            vendedorLoading: false,

            atividadeSelect: [],
            atividadeSelected: [],
            atividadeLoading: false,

            situacaoSelect: [],
            situacaoSelected: [],
            situacoesLoading: false,

            statusSelect: [],
            statusSelected: { id: 0, label: this.$t('todos').toUpperCase() },
            statusListaCompleta: [],
            statusLoading: false,

            // @86380 utilizado para exibir os valores conforme no dicionário.
            dicsStatus: {
                N: 'nao-enviado',
                E: 'processando',
                S: 'transmitido',
                C: 'cancelado',
                ED: 'em-edicao',
                AP: 'aguardando-aprovacao',
                A: 'aprovado',
                F: 'faturado',
                D: 'deletado',
                EI: 'problema-integracao-erp',
            },

            origemSelect: [],
            origemListaCompleta: [], // para armazenar os registros completos
            origemSelected: { id: 0, label: this.$t('todos').toUpperCase() },
            origemLoading: false,

            visitaSelect: [
                { value: 0, label: 'todos' },
                { value: 1, label: 'ja-visitados' },
                { value: 2, label: 'nao-visitados' },
            ],
            visitaSelected: null,

            cidadeSelect: [],
            cidadeSelected: [],
            cidadeLoading: false,

            regiaoSelect: [],
            regiaoSelected: [],
            regiaoLoading: false,

            geolocalizacaoSelect: [
                { value: 0, label: 'todos' },
                { value: 1, label: 'somente-quem-possui-geolocalização' },
                { value: 2, label: 'somente-quem-nao-possui-geolocalizacao' },
            ],
            geolocalizacaoSelected: null,

            contatoSelect: [
                { value: 0, label: 'todos' },
                { value: 1, label: 'somente-quem-possui-contatos' },
                { value: 2, label: 'somente-quem-nao-possui-contatos' },
            ],
            contatoSelected: null,

            naoVendaSelect: [
                { value: 0, label: 'todos' },
                { value: 1, label: 'somente-quem-possui-nao-venda' },
                { value: 2, label: 'somente-quem-nao-possui-nao-venda' },
            ],
            naoVendaSelected: null,

            statusComercialSelect: [],
            statusComercialSelected: [],
            statusComercialLoading: false,

            minDiasDesdeUltimaVenda: '',
            minDiasDesdeUltimaAtualizacao: '',

            // Filtros novos
            grupoEconomicoSelect: [],
            grupoEconomicoSelected: [],
            grupoEconomicoLoading: false,

            areainteresseSelect: [],
            areainteresseSelected: [],
            areainteresseLoading: false,

            propriedade: '',

            planosafraSelect: [
                { value: 0, label: 'todos' },
                { value: 1, label: 'clientes-com-planosafra-aberto' },
                { value: 2, label: 'clientes-sem-planosafra' },
            ],
            planosafraSelected: null,

            pdadetalhe: {},
            pdadetalheHasData: false,
        };
    },
    watch: {
        limparFiltros(val) {
            if (val) this.limparFiltrosSelecionados();
        },
    },
    created() {
        this.carregarEmpresas();
        this.verificaFiltroEmpresa();
        this.carregarStatusComerciais();
        this.carregarVendedores('');
        this.carregarAtividades('');
        this.carregarSituacoes('');
        this.carregarStatus();
        this.carregarOrigem();
        this.carregarCidades('');
        this.carregarRegioes('');
        // Filtros novos
        this.carregarGrupoEconomico('');
        this.carregarAreainteresse('');

        this.empresaSelected = this.empresaSelect[0];
        this.contatoSelected = this.contatoSelect[0];
        this.naoVendaSelected = this.naoVendaSelect[0];
        this.geolocalizacaoSelected = this.geolocalizacaoSelect[0];
        this.visitaSelected = this.visitaSelect[0];
        this.planosafraSelected = this.planosafraSelect[0];

        this.getModulo('CLIENTE').detalhe.forEach((d) => {
            d.invalid = false;
            d.msg = 'msg-campo-obrigatorio';
            this.$set(this.pdadetalhe, d.campo.toLowerCase(), d);
            // Caso tenha dados em pdadetalhe
            this.pdadetalheHasData = true;
        });
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        limparFiltrosSelecionados() {
            this.updateEmpresa(this.empresaSelect[0]);
            this.updateVendedor([]);
            this.updateAtividade([]);
            this.updateSituacao([]);
            this.updateStatus(this.statusSelect[0]);
            this.updateOrigem(this.origemSelect[0]);
            this.updateVisita(this.visitaSelect[0]);
            this.updateStatusComerciais([]);
            this.updateCidade([]);
            this.updateRegiao([]);
            this.updateMinDiasDesdeUltimaVenda('');
            this.updateMinDiasDesdeUltimaAtualizacao('');
            this.updateGeolocalizacao(this.geolocalizacaoSelect[0]);
            this.updateContatos(this.contatoSelect[0]);
            this.updateNaoVendas(this.naoVendaSelect[0]);
            // Filtros novos
            this.updateGrupoEconomico([]);
            this.updateAreainteresse([]);
            this.propriedade = '';
            this.updatePropriedade();
            this.updatePlanosafra(this.planosafraSelect[0]);

            this.$emit('filtrosLimpos', false);
        },
        verificaFiltroEmpresa() {
            this.clienteService.containsAssClienteEmpresa().then((r) => {
                let containsAssClienteEmpresa = r.content;
                this.mostraFiltroEmpresa =
                    this.empresaSelect.length > 1 && containsAssClienteEmpresa;
            });
        },
        carregarEmpresas() {
            // se for cliente, mostra todas as empresas relacionadas a ele
            if (this.$store.state.user.empresas.length > 1) {
                this.empresaSelect = this.empresaSelect.concat({
                    value: 0,
                    label: 'todas',
                    traduzir: true,
                });
            }
            this.empresaSelect = this.empresaSelect.concat(
                this.$store.state.user.empresas.map((e) => {
                    return { value: e.id, label: e.rsocial, traduzir: false };
                })
            );
        },
        updateEmpresa(empresaSelected) {
            this.empresaSelected = empresaSelected;
            if (this.mostraFiltroEmpresa) {
                this.$emit('update-filtro', {
                    nomeFiltro: 'empresa',
                    valor: this.empresaSelected['value'],
                });
            }
        },
        carregarVendedores(searchQuery) {
            this.vendedorLoading = true;
            this.colaboradorService
                .findListAssociated(searchQuery)
                .then((r) => {
                    this.vendedorSelect = r.content;
                    if (this.primeiraExecucao) {
                        this.mostraFiltroVendedor = this.vendedorSelect.length > 1;
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de vendedores. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.vendedorLoading = false;
                    if (this.primeiraExecucao) {
                        this.primeiraExecucao = false;
                        this.$emit('load-clientes');
                    }
                });
        },
        updateVendedor(vendedorSelected) {
            this.vendedorSelected = vendedorSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'vendedores',
                valor:
                    this.vendedorSelected.length == 0 ? [] : this.vendedorSelected.map((e) => e.id),
            });
        },
        carregarAtividades(searchQuery) {
            this.atividadeLoading = true;
            this.atividadeService
                .findAll(0, 50, searchQuery)
                .then((r) => {
                    this.atividadeSelect = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de atividades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.atividadeLoading = false;
                });
        },
        updateAtividade(atividadeSelected) {
            this.atividadeSelected = atividadeSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'atividades',
                valor: this.atividadeSelected.map((e) => e.id),
            });
        },
        carregarSituacoes(searchQuery) {
            this.situacoesLoading = true;
            this.situacaoService
                .findAllCombo(1000, searchQuery)
                .then((r) => {
                    this.situacaoSelect = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de situacoes. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.situacoesLoading = false;
                });
        },
        updateSituacao(situacaoSelected) {
            this.situacaoSelected = situacaoSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'situacoes',
                valor: this.situacaoSelected.map((e) => e.idsituacao),
            });
        },
        // @86830 carrega os status
        carregarStatus() {
            this.statusLoading = true;

            this.clienteService
                .getStatusClienteCombo()
                .then((r) => {
                    this.statusListaCompleta = [];
                    this.statusListaCompleta.push(this.statusSelected);
                    Object.entries(r.content).forEach(([key, val]) => {
                        let texto = val.toUpperCase();
                        this.statusListaCompleta.push({
                            id: key,
                            label:
                                texto in this.dicsStatus
                                    ? this.$t(this.dicsStatus[texto]).toUpperCase()
                                    : texto,
                        });
                    });
                    if (this.statusSelect.length == 0)
                        this.statusSelect = Object.assign([], this.statusListaCompleta);
                })
                .catch((e) => {
                    console.error('Erro ao carregar status.', e);
                })
                .finally((_) => {
                    this.statusLoading = false;
                });
        },
        updateStatus(val) {
            let temp = null;
            if (val) {
                temp = this.statusSelect.filter((v) => v.id == val.id);
                this.statusSelected = temp[0];
            } else {
                this.statusSelected = this.statusSelect[0];
            }
            this.$emit('update-filtro', {
                nomeFiltro: 'status',
                valor: this.statusSelected.id,
            });
        },
        // @86830 carrega as origens
        carregarOrigem() {
            this.origemLoading = true;

            this.clienteService
                .getOrigensClienteCombo()
                .then((r) => {
                    this.origemListaCompleta = [];
                    this.origemListaCompleta.push(this.origemSelected);
                    Object.entries(r.content).forEach(([key, val]) => {
                        this.origemListaCompleta.push({ id: key, label: val.toUpperCase() });
                    });
                    if (this.origemSelect.length == 0)
                        this.origemSelect = Object.assign([], this.origemListaCompleta);
                })
                .catch((e) => {
                    console.error('Erro ao carregar as origens.', e);
                })
                .finally((_) => {
                    this.origemLoading = false;
                });
        },
        // ORIGEM -- @86830 - Update do filtro com base nos valores inseridos para origem
        updateOrigem(val) {
            let temp = null;
            if (val) {
                temp = this.origemSelect.filter((v) => v.id == val.id);
                this.origemSelected = temp[0];
            } else {
                this.origemSelected = this.origemSelect[0];
            }
            this.$emit('update-filtro', {
                nomeFiltro: 'origem',
                valor: this.origemSelected.id,
            });
        },
        // @86830 - carrega os status conforme a origem, se é do sistema, carrega os status do sistema e vice versa.
        alterValuesStatusByOrigem() {
            this.statusSelect = Object.assign([], this.statusListaCompleta);
            if (this.origemSelected.id > 0) {
                this.statusSelect = this.statusSelect.filter((item) => item.id >= 0);
            } else if (this.origemSelected.id < 0) {
                this.statusSelect = this.statusSelect.filter((item) => item.id <= 0);
            }
        },
        // @86830 - carrega as origens conforme o status, se é do sistema, carrega as origens do sistema e vice versa.
        alterValuesOrigemByStatus() {
            this.origemSelect = Object.assign([], this.origemListaCompleta);
            if (this.statusSelected.id > 0) {
                this.origemSelect = this.origemSelect.filter((item) => item.id >= 0);
            } else if (this.statusSelected.id < 0) {
                this.origemSelect = this.origemSelect.filter((item) => item.id <= 0);
            }
        },
        updateVisita(visitaSelected) {
            this.visitaSelected = visitaSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'visita',
                valor: this.visitaSelected['value'],
            });
        },
        carregarCidades(searchQuery) {
            this.cidadeLoading = true;
            this.cidadeService
                .findAll(0, 50, searchQuery)
                .then((r) => {
                    this.cidadeSelect = r.content;
                    if (this.cidadeSelected.length > 0) {
                        for (let cidade of this.cidadeSelected) {
                            let count = 0;
                            this.cidadeSelect.map((e) => {
                                if (e.idcidade == cidade.idcidade) {
                                    count++;
                                }
                            });
                            if (count == 0) {
                                this.cidadeSelect.unshift(cidade);
                            }
                        }
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de cidades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.cidadeLoading = false;
                });
        },
        updateCidade(cidadeSelecionada) {
            this.cidadeSelected = cidadeSelecionada;
            this.$emit('update-filtro', {
                nomeFiltro: 'cidades',
                valor: this.cidadeSelected.map((e) => e.id),
            });
        },
        carregarRegioes(searchQuery) {
            this.regiaoLoading = true;
            this.regiaoService
                .findAllCombo(searchQuery)
                .then((r) => {
                    this.regiaoSelect = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de cidades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.regiaoLoading = false;
                });
        },
        updateRegiao(regioes) {
            this.regiaoSelected = regioes;
            this.$emit('update-filtro', {
                nomeFiltro: 'regioes',
                valor: this.regiaoSelected.map((e) => e.id),
            });
        },
        updateGeolocalizacao(geolocalizacaoSelected) {
            this.geolocalizacaoSelected = geolocalizacaoSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'geoLocalizacao',
                valor: this.geolocalizacaoSelected['value'],
            });
        },
        updateContatos(contatoSelected) {
            this.contatoSelected = contatoSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'contatos',
                valor: this.contatoSelected['value'],
            });
        },
        updateNaoVendas(naoVendaSelected) {
            this.naoVendaSelected = naoVendaSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'naoVenda',
                valor: this.naoVendaSelected['value'],
            });
        },
        carregarStatusComerciais(searchQuery) {
            this.statusComercialLoading = true;
            this.statusComercialService
                .findAllCombo(searchQuery)
                .then((r) => {
                    this.statusComerciais = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de status comercial. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.statusComercialLoading = false;
                });
        },
        updateStatusComerciais(statusComercialSelecionado) {
            this.statusComercialSelected = statusComercialSelecionado;
            this.$emit('update-filtro', {
                nomeFiltro: 'statusComerciais',
                valor: this.statusComercialSelected.map((s) => s.tipo),
            });
        },
        updateMinDiasDesdeUltimaVenda(minDiasDesdeUltimaVenda) {
            this.minDiasDesdeUltimaVenda = minDiasDesdeUltimaVenda;
            this.$emit('update-filtro', {
                nomeFiltro: 'minDiasDesdeUltimaVenda',
                valor: this.minDiasDesdeUltimaVenda === '' ? -1 : parseInt(minDiasDesdeUltimaVenda),
            });
        },
        updateMinDiasDesdeUltimaAtualizacao(minDiasDesdeUltimaAtualizacao) {
            this.minDiasDesdeUltimaAtualizacao = minDiasDesdeUltimaAtualizacao;
            this.$emit('update-filtro', {
                nomeFiltro: 'minDiasDesdeUltimaAtualizacao',
                valor:
                    this.minDiasDesdeUltimaAtualizacao === ''
                        ? -1
                        : parseInt(minDiasDesdeUltimaAtualizacao),
            });
        },
        // FILTROS NOVOS
        updatePropriedade() {
            this.$emit('update-filtro', {
                nomeFiltro: 'propriedade',
                valor: this.removeToSearch(this.propriedade),
            });
        },
        carregarGrupoEconomico(searchQuery) {
            this.grupoEconomicoLoading = true;
            this.grupoEconomicoService
                .findAllCombo(searchQuery)
                .then((r) => {
                    this.grupoEconomicoSelect = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de grupoEconomico. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.grupoEconomicoLoading = false;
                });
        },
        updateGrupoEconomico(grupoEconomico) {
            this.grupoEconomicoSelected = grupoEconomico;
            this.$emit('update-filtro', {
                nomeFiltro: 'grupoeconomico',
                valor: this.grupoEconomicoSelected.map((e) => e.id),
            });
        },
        carregarAreainteresse(searchQuery) {
            this.areainteresseLoading = true;
            this.areaInteresseService
                .findAllCombo(searchQuery)
                .then((r) => {
                    this.areainteresseSelect = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de areainteresse. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.areainteresseLoading = false;
                });
        },
        updateAreainteresse(areainteresse) {
            this.areainteresseSelected = areainteresse;
            this.$emit('update-filtro', {
                nomeFiltro: 'areainteresse',
                valor: this.areainteresseSelected.map((e) => e.id),
            });
        },
        updatePlanosafra(planosafraSelected) {
            this.planosafraSelected = planosafraSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'planosafra',
                valor: this.planosafraSelected['value'],
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    overflow: initial;
    color: $darker-gray-color;
    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }
    .card-content {
        padding-top: 0px;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0.75rem;
        margin: 0px;
        .card-content-section {
            padding: 0px;
            margin-top: 0.75rem;
            margin-bottom: 0px;
            margin-left: 0px;
            margin-right: 0px;
        }
        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
    }
}

.filtro-header {
    display: flex;
    align-items: center;
}

.filtros-extras {
    font-size: 12px;
}
</style>
